let xmlRequest = `
<?xml version="1.0" encoding="utf-8"?>
<request>
    <transportOrder>
        <transportCode>装车单号, string (50), 必填</transportCode>
        <state>状态, string (50)</state>
        <vehicalNo>车牌号, string (50), 必填</vehicalNo>
        <vehicleType>车型, string (50)</vehicleType>
        <driverName>司机姓名, string (50), 必填</driverName>
        <driverMobile>司机电话, string (50), 必填</driverMobile>
        <loadingBy>装车人, string (50)</loadingBy>
        <loadingFinishedAt>装车完成时间, string (19), YYYY-MM-DD HH:MM:SS, 必填</loadingFinishedAt>
        <loadingWeight>装车总重量, float</loadingWeight>
        <loadingVolumn>装车总体积, float</loadingVolumn>
        <electronicSealNo>电子铅封号, string (50)</electronicSealNo>
        <carrierCode>承运商编号, string (50), 必填</carrierCode>
        <carrierName>承运商名称, string (50), 必填</carrierName>
        <userDefined1>自定义1, string (50)</userDefined1>
        <userDefined2>自定义2, string (50)</userDefined2>
        <userDefined3>自定义3, string (50)</userDefined3>
        <userDefined4>自定义4, string (50)</userDefined4>
        <userDefined5>自定义5, string (50)</userDefined5>
    </transportOrder>
    <orderLines>
        <orderLine>
            <deliveryOrderCode>ERP出库单号(ERP分配), string (50), 必填</deliveryOrderCode>
            <wmsOrderCode>WMS出库单号(WMS分配), string (50), 必填</wmsOrderCode>
            <loadingSequence>装载顺序, string (50), 必填</loadingSequence>
            <carrryRoute>发货路线, string (50)</carrryRoute>
            <userDefined1>自定义字段1, string (50)</userDefined1>
            <userDefined2>自定义字段2, string (50)</userDefined2>
            <userDefined3>自定义字段3, string (50)</userDefined3>
            <userDefined4>自定义字段4, string (50)</userDefined4>
            <userDefined5>自定义字段5, string (50)</userDefined5>
        </orderLine>
    </orderLines>
</request>
`

let xmlResponse = `
<?xml version="1.0" encoding="utf-8"?>
<response>
    <flag>success|failure</flag>
    <code>响应码</code>
    <message>响应信息</message>
</response>
`

export default {
  xmlRequest,
  xmlResponse
}



// WEBPACK FOOTER //
// ./src/data/openapi/openapi.transport.create.js